import React, { useState, useEffect } from 'react';

import { getImageName } from "../../api/iposApi";
import Image from '../../components/Image';
import PizzaPart from '../../components/PizzaPart';
import FormattedPrice from '../../components/FormattedPrice';

import './OrderInfoItem.scss';

const OrderInfoItem = ({ item, currentLanguageId = 2, shortInfo = false, branchInfo }) => {
  return (
    <div className={ 'order-item-info' }>
      { !shortInfo && (
        <div className={ 'img-block' }>
          <Image image={ getImageName(branchInfo, item.menuItem) } useDefaultEmpty = {true} />          
        </div>
      )}
      <div className={ 'info-block' }>
        <div className={ 'parent-item-info' }>
          <div className={ 'item-info-block' }>
            <div className={ 'item-name' }>{item.menuItem.item_name}</div>
            <div className={ 'item-description' }>{ currentLanguageId === 2 ? item.menuItem.details_txt : item.menuItem.details_eng_txt}</div>
            <div className={ 'instructions' }>
              {
                item.instructions.map((instruction, index) => (
                  <div className={ 'instruction' }>
                    { instruction.menuItem.item_name }
                  </div>
                ))
              }

            </div>
            { item.freeInstruction && (
              <div className={ 'free-instruction-block' }>
                <div className={ 'free-instruction' }>
                  { item.freeInstruction }
                </div>
              </div>
            )}

          </div>

          <div className={ 'item-quantity-info-block' }>
            <div className={ 'item-quantity-info' }>x {item.orderItem.quantity}</div>
          </div>

          <div className={ 'item-price-block' }>
            <div className={ 'item-price' }>
              <FormattedPrice price={ item.orderItem.price } />
            </div>
          </div>
        </div>

        {item.supplements.map(supplement => (
          <div className={ 'item-supplement-info' }>
            <div className={ 'item-info-block' }>
              <div className={ 'item-name' }>

                <span> <PizzaPart part={ supplement.orderItem.pizza_item_part } /> {supplement.menuItem.item_name} </span>
              </div>
            </div>

            <div className={ 'item-quantity-info-block' }>
              <div className={ 'item-quantity-info' }>x {supplement.orderItem.quantity}</div>
            </div>

            <div className={ 'item-price-block' }>
              <div className={ 'item-price' }>
                <FormattedPrice price={ supplement.orderItem.price } />
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default OrderInfoItem;
